import { render, staticRenderFns } from "./EmptyCallView.vue?vue&type=template&id=c749efcc&scoped=true"
import script from "./EmptyCallView.vue?vue&type=script&lang=js"
export * from "./EmptyCallView.vue?vue&type=script&lang=js"
import style0 from "./EmptyCallView.vue?vue&type=style&index=0&id=c749efcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c749efcc",
  null
  
)

export default component.exports